import React, { useEffect } from 'react';
import './SectionHero.scss';
import img2 from '../../../assets/images/backHome.png';
import img from '../../../assets/images/imgHeroRes.png';
import { Button, Flex, Image } from 'antd';
import { FaLongArrowAltDown } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import Aos from 'aos';
import { useNavigate } from 'react-router-dom';
const SectionHero = ({ t }) => {
  const navigate = useNavigate();
  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  }, []);
  const { currentLang } = useSelector((state) => state.user);
  return (
    <section
      className={
        'section-hero' + (currentLang === 'ar' ? ' section-hero-ar' : '')
      }
    >
      <div className="hero-text">
        <div data-aos={currentLang === 'en' ? 'fade-right' : 'fade-left'}>
          <h1
            className="hero-title-one"
            data-aos={currentLang === 'en' ? 'fade-right' : 'fade-left'}
            data-aos-delay="200"
            style={{
              transform:
                currentLang === 'en' ? 'translateX(70px)' : 'translateX(-20px)',
            }}
          >
            {t.Immerse}
          </h1>
        </div>
        <div
          data-aos={currentLang === 'en' ? 'fade-right' : 'fade-left'}
          data-aos-delay="300"
        >
          <h1
            className="hero-title-two"
            data-aos={currentLang === 'en' ? 'fade-right' : 'fade-left'}
            style={{
              transform:
                currentLang === 'en' ? 'translateX(0px)' : 'translateX(0px)',
            }}
          >
            {t.Empower}
          </h1>
        </div>
        <div
          data-aos={currentLang === 'en' ? 'fade-right' : 'fade-left'}
          data-aos-delay="400"
        >
          <div
            className="hero-title-three-container"
            data-aos="fade-up"
            style={{
              transform:
                currentLang === 'en'
                  ? 'translateX(134px)'
                  : 'translateX(-80px)',
            }}
          >
            <Flex
              align="start"
              justify="start"
              className="hero-content-three"
              gap={30}
              style={{ width: '100%', height: '100%', flexDirection: 'column' }}
            >
              <h1 className="hero-title-three">{t.Excel}</h1>
              <p className="hero-paragraph-three-text">
                {' '}
                {t.sectionHeroParagraph}{' '}
              </p>
              <div className="btn-hero">
                <Button
                  type="primary"
                  className="btn-none-700"
                  onClick={() =>
                    navigate(
                      `${currentLang === 'en' ? '/projects' : '/ar/projects'}`
                    )
                  }
                >
                  {t.OurPortfolio}
                </Button>
              </div>
            </Flex>
          </div>
        </div>
      </div>
      <div
        data-aos="fade-down"
        data-aos-duration="2000"
        data-aos-delay="400"
        className="hero-img-2"
      >
        <Image
          src={img2}
          preview={false}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
          }}
        />
      </div>
      <div className="hero-img" data-aos="fade-up" data-aos-duration="2000">
        <Image
          src={img}
          preview={false}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
          }}
        />
      </div>
      <div
        className="btn-down"
        onClick={() =>
          window.scrollTo({ top: 1000, left: 0, behavior: 'smooth' })
        }
      >
        {t.ExploreMore}
        <div className="icon-down">
          <FaLongArrowAltDown />
        </div>
      </div>
      <div className="btn-hero" data-aos="zoom-in" data-aos-duration="2000">
        <Button
          type="primary"
          className="btn-700"
          onClick={() =>
            navigate(`${currentLang === 'en' ? '/projects' : '/ar/projects'}`)
          }
        >
          {t.OurPortfolio}
        </Button>
      </div>
    </section>
  );
};

export default SectionHero;
